function GemPagesVariantChangeHandler() {
    const gp = document.querySelector('gp-product-variants');
    if (!gp) return;

    document.addEventListener('change', () => {
        kachingJob(gp);
    });
    kachingJob(gp);
}

function kachingJob(gp) {
    const selectedVariant = gp.querySelector(".option-item-active");
    if (!selectedVariant) return;
    
    const selectedInput = selectedVariant.querySelector("input");
    if (!selectedInput) return;
    
    const title = selectedInput.value;
    syncKachingBundleSelectsToTitle(title);
}

function syncKachingBundleSelectsToTitle(title) {
  if (!title) return;

  const products = document.querySelectorAll(".kaching-bundles__bundle-products__product");
  products.forEach((productEl) => {
    const select = productEl.querySelector(".kaching-bundles__bar-variant-select");
    if (!select) return;

    if (select.value === title) return;

    const match = Array.from(select.options).find(opt => opt.value === title);

    if (!match) return;

    select.value = match.value;

    select.dispatchEvent(new Event("change", { bubbles: true }));
  });
}

document.addEventListener('DOMContentLoaded', () => {
    GemPagesVariantChangeHandler();
});